import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import PropTypes from 'prop-types';
import { defaultElementHeight } from '../constants';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";

var LayerRow = function LayerRow(_ref) {
  var layerRow = _ref.layerRow,
      LayerRowItemComponent = _ref.LayerRowItemComponent,
      layers = _ref.layers,
      onLayerClick = _ref.onLayerClick,
      toggleLayer = _ref.toggleLayer,
      top = _ref.top,
      mapKey = _ref.mapKey,
      activeLevel = _ref.activeLevel,
      dayWidth = _ref.dayWidth,
      getX = _ref.getX,
      mouseX = _ref.mouseX,
      period = _ref.period,
      periodLimit = _ref.periodLimit,
      vertical = _ref.vertical,
      width = _ref.width;
  var timelineParams = {
    activeLevel: activeLevel,
    dayWidth: dayWidth,
    getX: getX,
    mouseX: mouseX,
    period: period,
    periodLimit: periodLimit,
    vertical: vertical,
    width: width
  };

  var _onClick = function onClick(timelineLayerPeriodItem, timelineLayer) {
    // todo dispatch onLayerClick
    if (typeof toggleLayer === 'function') {
      toggleLayer(timelineLayerPeriodItem, timelineLayer, mapKey, layerRow, layers);
    }

    if (typeof onLayerClick === 'function') {
      onLayerClick(timelineLayerPeriodItem, timelineLayer, mapKey, layerRow, layers);
    }
  };

  var elementHeight = layerRow.elementHeight || defaultElementHeight;

  var getLayer = function getLayer(layer) {
    return /*#__PURE__*/_jsx(LayerRowItemComponent, _objectSpread({
      layer: layer,
      top: top,
      height: elementHeight,
      onClick: function onClick(timelineLayerPeriodItem) {
        return _onClick(timelineLayerPeriodItem, layer);
      },
      mapKey: mapKey
    }, timelineParams), "".concat(JSON.stringify(layer)));
  };

  var layerRowsElms = [];

  if ((layerRow === null || layerRow === void 0 ? void 0 : layerRow.items.length) > 0) {
    layerRowsElms = layerRow.items.map(getLayer);
  }

  return /*#__PURE__*/_jsx(_Fragment, {
    children: layerRowsElms
  });
};

LayerRow.propTypes = {
  LayerRowItemComponent: PropTypes.func,
  activeLevel: PropTypes.string,
  dayWidth: PropTypes.number,
  getX: PropTypes.func,
  layerRow: PropTypes.shape({
    elementHeight: PropTypes.any,
    items: PropTypes.array
  }),
  layers: PropTypes.array,
  mapKey: PropTypes.string,
  mouseX: PropTypes.number,
  onLayerClick: PropTypes.func,
  period: PropTypes.object,
  periodLimit: PropTypes.object,
  toggleLayer: PropTypes.func,
  top: PropTypes.number,
  vertical: PropTypes.bool,
  width: PropTypes.number
};
export default LayerRow;